import { Typography, useTranslate } from '@prenuvo/halo';

import {
  ACTIVITY_LOG_ACTION,
  FullObject as FullObjectModel,
  REPORT_FINDING_STATUS,
  ReportFindingConditionDetail,
} from '@/api';

import { ActionClass } from './activity-log.constant';
import { ActivityLogDetail } from './activity-log-detail.component';
import { ConditionDetail } from './condition-detail.component';

type AiActivityLogProps = {
  action: ActionClass;
  fullObject: FullObjectModel;
};

export function AiActivityLog({ action, fullObject }: AiActivityLogProps) {
  const { conditionDetail, finding, organ, status } = fullObject;
  const translate = useTranslate();

  const updatedAction =
    status === REPORT_FINDING_STATUS.DEPRECATED ? ACTIVITY_LOG_ACTION.REJECT : action;
  const aiFindingStatus = translate(
    status === REPORT_FINDING_STATUS.DEPRECATED
      ? 'FCT.ACTIVITY_LOGS.AI_FINDING.AI_FINDING_STATUS.REJECTED'
      : 'FCT.ACTIVITY_LOGS.AI_FINDING.AI_FINDING_STATUS.APPLIED',
  );

  if (!organ || !finding) {
    return null;
  }

  return (
    <>
      <Typography
        className="mt-2"
        translationKey="FCT.ACTIVITY_LOGS.AI_FINDING.TITLE"
        variant="paragraph-sm-bold"
      />

      <div className="mt-4 flex gap-8">
        <ActivityLogDetail
          action={updatedAction}
          title={translate('FCT.ACTIVITY_LOGS.AI_FINDING.ORGAN_LABEL') as string}
          value={organ}
        />
        <ActivityLogDetail
          action={updatedAction}
          title={translate('FCT.ACTIVITY_LOGS.AI_FINDING.FINDING_LABEL') as string}
          value={finding}
        />
      </div>

      <Typography
        className="mt-2"
        translationKey="FCT.ACTIVITY_LOGS.AI_FINDING.PARAMETERS_LABEL"
        variant="paragraph-sm-bold"
      />

      <div className="mt-2 flex flex-wrap gap-6">
        {conditionDetail?.map((condition: ReportFindingConditionDetail) =>
          condition.value ? (
            <div key={condition.name}>
              <ConditionDetail
                key={condition.name}
                action={updatedAction}
                conditionDetail={condition}
                fieldName={condition.name}
                fullObject={fullObject}
              />
            </div>
          ) : null,
        )}
      </div>

      <div className="mt-2">
        <ActivityLogDetail
          action={updatedAction}
          title={translate('FCT.ACTIVITY_LOGS.AI_FINDING.STATUS_LABEL') as string}
          value={aiFindingStatus as string}
        />
      </div>
    </>
  );
}
